<template>
  <c-link v-bind="$attrs" @click="$emit('click', $event)">
    <slot />
  </c-link>
</template>

<script setup>
import CLink from '@convenia/components/CLink'

defineEmits([ 'click' ])
</script>
